import React, { useState, useContext } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//access history
import { useHistory } from "react-router-dom";

//helper functions
import { deleteIndividualCluster } from "./helpers";

//components
import DeleteClusterModal from "../../components/console/GeneralModal";
import ClusterRowMobileInfoHTMLContentTop from "./ClusterRowMobileInfoHTMLContentTop";
import ClusterRowMobileInfoHTMLContentBottom from "./ClusterRowMobileInfoHTMLContentBottom";
import ClusterRowMobileInfoHTMLContentActions from "./ClusterRowMobileInfoHTMLContentActions";

//material ui
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";

const ClusterRowMobileInfoContent = ({
  clusterInfo,
  setClusters,
  clusters,
}) => {
  //state for opening and closing the modal
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  //when clicking the delete icon, the modal opens up
  //asking the user if they're sure to delete it
  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  //access global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to use history
  const history = useHistory();

  //closes the modal
  const closeModal = () => {
    setIsDeleteModalOpen(false);
  };

  //function run when user confirms that cluster should be deleted. Makes API call
  const deleteCluster = () => {
    closeModal();

    deleteIndividualCluster(
      setClusters,
      clusters,
      clusterInfo,
      history,
      state,
      setState
    );
  };

  const useStyles = makeStyles({
    root: {
      width: 350,
      height: "fit-content",
      background: state.theme === "dark" ? "#122742" : "#fff",
    },
    id: {
      textDecoration: "underline",
      fontFamily: '"Alegreya Sans", sans-serif',
      color: state.theme === "dark" ? "#fa0171" : "#fa0171",
      textAlign: "center",
      fontSize: "25px",
    },
    content: {
      display: "flex",
      justifyContent: "flex-start",
      flexDirection: "column",
      padding: "0 20px 0 35px",
      alignItems: "flex-start",
      margin: "20px 0",
      color: state.theme === "dark" ? "#fff" : "#00152b",
    },
    text: {
      textAlign: "start",
      color: state.theme === "dark" ? "#fff" : "#00152b",
      wordWrap: "break-word",
      fontFamily: '"Alegreya Sans", sans-serif',
      fontSize: "19px",
      paddingLeft: "5px",
    },
    actions: {
      padding: "0 48px 0 48px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "50px",
    },
    label: {
      fontFamily: '"Alegreya Sans", sans-serif',
      fontSize: "16px",
      paddingLeft: "4px",
    },
    labelDiv: {
      display: "flex",
      alignItems: "center",
    },
  });

  //material ui classes
  const classes = useStyles();

  const { percentage } = clusterInfo.data.status.state;

  return (
    <>
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent>
            <ClusterRowMobileInfoHTMLContentTop
              clusterInfo={clusterInfo}
              classes={classes}
              percentage={percentage}
            />
            <ClusterRowMobileInfoHTMLContentBottom
              clusterInfo={clusterInfo}
              classes={classes}
            />
          </CardContent>
        </CardActionArea>
        <ClusterRowMobileInfoHTMLContentActions
          classes={classes}
          openDeleteModal={openDeleteModal}
          clusterInfo={clusterInfo}
        />
      </Card>
      <DeleteClusterModal
        title="Delete Cluster?"
        text={`Cluster ${clusterInfo.data.id} will be permanently deleted.`}
        actionText="Delete"
        modalDescription="delete WCS cluster modal dialog"
        actionFunction={deleteCluster}
        cancelText="Cancel"
        cancelFunction={closeModal}
        open={isDeleteModalOpen}
        closeModal={closeModal}
      />
    </>
  );
};

export default ClusterRowMobileInfoContent;
